/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRegistrationV1ProfileVersionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_REGISTRATION_V1_PROFILE_VERSION_STATE_ENTITY_NAME = 'ixc.registration.v1.ProfileVersion';
export const ixcRegistrationV1ProfileVersionStateEntity = new schema.Entity<IxcRegistrationV1ProfileVersionState>(IXC_REGISTRATION_V1_PROFILE_VERSION_STATE_ENTITY_NAME, {}, { idAttribute: 'profileVersionId' });

